<template>
    <div>
        <span>
            {{formatUSDate()}}
        </span>
    </div>


</template>

<script>
    export default {
        name: 'np-date',
        props: {
            value: {
                default: ''
            },
            type: {
                default: 'date_time'
            }
        },
        methods: {
            formatUSDate: function () {
                if(this.value !== '' && this.value != null) {
                    let dateValue =  new Date(this.value.replace(/ /g, "T") + 'Z');
                    let strTargetDate = ((dateValue.getUTCMonth() + 1 >= 10) ? dateValue.getUTCMonth() + 1 : '0' + (dateValue.getUTCMonth() + 1)) + '/' +
                        ((dateValue.getUTCDate() >= 10) ? dateValue.getUTCDate() : '0' + dateValue.getUTCDate()) + '/'
                        + dateValue.getUTCFullYear();

                    if(this.type === 'date_time') {
                        strTargetDate += (' '
                            + ((dateValue.getUTCHours() >= 10) ? dateValue.getUTCHours() : '0' + (dateValue.getUTCHours())) + ':'
                            + ((dateValue.getUTCMinutes() >= 10) ? dateValue.getUTCMinutes() : '0' + (dateValue.getUTCMinutes()))
                        );
                    }
                    return strTargetDate;
                } else {
                    return '-';
                }
            },
            formatDate: function () {
                if(this.value !== '' && this.value != null) {
                    let dateValue =  new Date(this.value.replace(/ /g, "T") + 'Z');
                    let strTargetDate = ((dateValue.getUTCDate() >= 10) ? dateValue.getUTCDate() : '0' + dateValue.getUTCDate()) + '-'
                        + ((dateValue.getUTCMonth() + 1 >= 10) ? dateValue.getUTCMonth() + 1 : '0' + (dateValue.getUTCMonth() + 1)) + '-'
                        + dateValue.getUTCFullYear();

                    if(this.type === 'date_time') {
                        strTargetDate += (' '
                            + ((dateValue.getUTCHours() >= 10) ? dateValue.getUTCHours() : '0' + (dateValue.getUTCHours())) + ':'
                            + ((dateValue.getUTCMinutes() >= 10) ? dateValue.getUTCMinutes() : '0' + (dateValue.getUTCMinutes()))
                        );
                    }
                    return strTargetDate;
                } else {
                    return '-';
                }
            }
        }
    };
</script>>
